import {FC, useMemo, useState} from 'react';
//formik
import {useFormikContext} from 'formik';
import {CreateEventFormValues} from '@/components/Organization/Dashboard/CreateNewEvent/formConfiguration';
//mui
import {Box, Typography} from '@mui/material';
//constants
import {ADD_SPONSOR, ERROR, PRIMARY, SPONSORS, SUBTITLE1, TEXT} from '@/utils/constants';
//icons
import {ReactComponent as PlusIcon} from '@/assets/icons/plus.svg';
//components
import Button from '@/shared/components/Button';
import SponsorsList from '@/components/Organization/Dashboard/CreateNewEvent/EventSetting/EventSponsors/SponsorsList';
//styles
import {eventSponsorsStyle} from '@/components/Organization/Dashboard/CreateNewEvent/EventSetting/EventSponsors/EventSponsors.styles';
import { useAppSelector } from '@/store/hooks';
import { getTeamSelector } from '@/store/organization';
import { ITeamRole } from '@/utils/enums';

const SponsorSettingsList: FC = () => {
  const {errors, touched} = useFormikContext<CreateEventFormValues>();
  const team = useAppSelector(getTeamSelector);

  const isStandartMember = !!team && team.role === ITeamRole.STANDART;

  const isEmptySponsors = useMemo(() => errors.sponsors && touched.sponsors, [errors, touched]);

  const [isOpenAddSponsorModal, setIsOpenAddSponsorModal] = useState(false);

  const handleChangeAddSponsorModal = () => setIsOpenAddSponsorModal(!isOpenAddSponsorModal);

  return (
    <Box sx={eventSponsorsStyle.wrapper}>
      <Typography variant={SUBTITLE1} sx={{...eventSponsorsStyle.title, ...(isStandartMember && {color: 'text.disabled'})}}>
        {SPONSORS}
      </Typography>

      <Typography sx={{...eventSponsorsStyle.afterTitle, ...(isStandartMember && {color: 'text.disabled'})}}>
        Add sponsors to display logos and recognition on your event page.
      </Typography>

      <SponsorsList isAddModalOpen={isOpenAddSponsorModal} onAddModalChange={handleChangeAddSponsorModal} isEditMode />

      <Button
        title={ADD_SPONSOR}
        variant={TEXT}
        color={isEmptySponsors ? ERROR : PRIMARY}
        startIcon={<PlusIcon />}
        disableRipple
        sx={eventSponsorsStyle.button}
        onClick={handleChangeAddSponsorModal}
		disabled={isStandartMember}
      />
    </Box>
  );
};

export default SponsorSettingsList;
